
const path = window.location.href;
const header = document.getElementById("section-header");
if (header) {
  console.log('hesder');
  // ページが読み込まれた後、ヘッダーを非表示にする
  window.addEventListener('load', function() {
    console.log('blocking header.');
    header.style.display = "none";

    const l_container = document.getElementsByClassName('l_container')[0];
    l_container.style.transform = 'translateY(0)';
    
    const announcementElem = document.getElementById('shopify-section-announcement');
    announcementElem.style.display = "none";
  });
}
